import { render, staticRenderFns } from "./GalleryBlock.vue?vue&type=template&id=cfa710da"
import script from "./GalleryBlock.vue?vue&type=script&lang=ts"
export * from "./GalleryBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports